import * as React from 'react';
import * as DetectBrowser from 'detect-browser';
import { CHROME, FIREFOX, EDGE, SAFARI, SAFARI_ON_IOS, CHROME_ON_IOS } from './DetectionConstants';

export const renderBrowserWarningMessage = (isNotSupported: boolean, isUnderHeader?: boolean): JSX.Element => {
  if (isNotSupported) {

    if (isUnderHeader) {
      return(
        <div className="row justify-content-center mt-2">
          <div className="col-auto alert alert-danger align-self-center">
            Warning !! M3 runs best on (Desktop) Chrome, FireFox, Safari, or Edge.<br/>
            It may not work well on other browsers and mobile browsers.
          </div>
        </div>
      );
    } else {
      return(
        <div className="row no-gutters">
          <div className="col-12 alert alert-danger">
            M3 runs best on (Desktop) Chrome, FireFox, Safari, or Edge.<br/>
            It may not work well on other browsers and mobile browsers.
          </div>
        </div>
      );
    }

  } else {
    return null;
  }
};

export const isBrowserNotSupported = (): boolean => {
  if (DetectBrowser.detect()) {
    return(
      (
        !DetectBrowser.detect().name.toLowerCase().includes(CHROME) &&
        !DetectBrowser.detect().name.toLowerCase().includes(FIREFOX) &&
        !DetectBrowser.detect().name.toLowerCase().includes(EDGE) &&
        !DetectBrowser.detect().name.toLowerCase().includes(SAFARI) &&
        !DetectBrowser.detect().name.toLowerCase().includes(SAFARI_ON_IOS)
      ) ||
      DetectBrowser.detect().name.toLowerCase() === CHROME_ON_IOS
    );
  } else {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/commons/BrowserWarning.tsx